<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-select v-model="query.siteIds[0]" size="small" @change="onSearchBtnClick">
      <el-option
        v-for="site in filterSites"
        :key="site.id"
        :value="site.id"
        :label="site.name"
      />
    </el-select>

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch :default-unit-prop.sync="unitProp" />
      </template>

      <chart-group
        v-for="(factorChartGroup, index) in factorChartGroups"
        :key="`${currentSite.id}-${index}`"
        ref="chart-groups"
        :site="currentSite"
        :default-factor-ids="factorChartGroup"
        :original-data="dataList"
        :unit-prop="unitProp"
        :query="currentQuery"
        :site-factor-map="siteFactorMap"
        :factor-site-map="factorSiteMap"
        :complete-all-data="completeAllData"
        :no-data-reason-map="noDataReasonMap"
        :filter-site-map="filterSiteMap"
        :dimension="dimension"
        @rendered="onChartRendered"
      />
      <!-- :click-handler="setHighChartOpt" -->
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'
import ChartGroup from './ChartGroup'

export default {
  name: 'VOCsOzonePollutantAnalysis',
  routeInfo: {
    label: '臭氧污染概况分析',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {
    ChartGroup,
    UnitSwitch,
    DataWrapper,
    DataTimeQuery,
    LayoutContent
  },
  data: () => ({
    query: {
      isFuse: false,
      isMultipleIntegral: true
    },
    chartType: 'line',
    stackType: 0,
    count: 0,
    dataList: []
  }),
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.ULTRAVIOLET_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PAN_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.JNO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HONO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false)
      ]
    },
    aggregationFactorGroups () {
      return this.factorGroups.filter(factorGroup => factorGroup.parentId === 'm30000')
    },
    downloadName: () => '臭氧污染概况分析',
    currentSite () {
      const [siteId] = this.currentQuery.siteIds || this.query.siteIds
      return this.filterSites.find(site => site.id === siteId)
    },
    factorChartGroups () {
      const {currentSite} = this

      if (currentSite) {
        const groups = [
          // O3
          ['1006'],
          // 风速风向、温度、湿度、气压、UV辐射计、光解光谱仪 jH2O2、jHCHO_M、jHCHO_R、jHONO、jNO3_M、jNO3_R、jNO2、jO1D
          ['1012', '1013', '1010', '1011', '1014', '1018', '4000', '4001', '4002', '4003', '4004', '4005', '4006', '4007'],
          // HONO、PAN
          ['6700', '6001'],
          // VOCs分类、NOx
          this.aggregationFactorGroups.map(factorGroup => factorGroup.id).concat(['1004'])
        ]
        const groupMap = groups.reduce((map, ids, index) => ids.reduce((map, id) => {
          let group = map[id]

          if (!group) {
            group = map[id] = []
          }

          group.push(index)

          return map
        }, map), {})

        return Object.values(Object.values(this.siteFactorMap[currentSite.id].map).reduce((map, factor) => {
          const {factorId} = factor
          const groupInfos = groupMap[factorId] || groupMap[factor.parentId]

          if (groupInfos) {
            groupInfos.forEach(groupIndex => {
              let groups = map[groupIndex]

              if (!groups) {
                groups = map[groupIndex] = []
              }

              groups.push(factorId)
            })
          }

          return map
        }, {}))
      }

      return []
    }
  },
  methods: {
    getData () {
      this.changeLoadStatus(true)
      let query = JSON.parse(JSON.stringify(this.query))
      query.factorIds = this.factorChartGroups.flat()

      const {currentQuery} = this

      const requests = [
        this.$api.Data.getHistoryData(currentQuery)
      ]

      let successCallback = this.setDataList

      if (this.requestNoDataInfo) {
        requests.push(this.$api.NoData.getNoDataListBySite(currentQuery))
        successCallback = this.setAllDataList
      }

      Promise.all(requests).then(successCallback).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setDataList (dataList) {
      this.dataList = Object.freeze(dataList)
    },
    onChartRendered () {
      this.count++

      if (this.factorChartGroups.length === this.count && this.count > 0) {
        this.$refs['chart-groups'][0].getChartComponent().connect(this.$refs['chart-groups'].map(component => component.getChartComponent()))
        this.count = 0
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/01OzonePollutantAnalysis/index.vue